import { useTranslation } from "react-i18next"
import React, { Fragment, useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { getRegionOrder } from "../../../../../../redux/actions/OrderAction"
import { ICON_CONSTANTS } from "../../../../../../constants/ImageConstants"
import SVG from "react-inlinesvg"
import { Accordion } from "../../../../../../component/atoms/Expands"
import { convertM2ToHectare } from "../../../../../helpers/TextHelper"
import { AccordionContent } from "./AccordionContent"
import { AREA_ACTIVITY_TYPE } from "../../../../../../constants/InitTypeConstants.js"

export const PreviewBulkErpForm = ({ data }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [datalist, setDataList] = useState([])
  const [area, setArea] = useState(0)

  useEffect(() => {
    dispatch(getRegionOrder())
  }, [])

  useEffect(() => {
    if (data) {
      setDataList(data)
      setArea(
        data.reduce((accumulator, item) => {
          return accumulator + parseFloat(item.worked_area)
        }, 0)
      )
    }
  }, [data])

  const dataListCardHeader = [
    {
      title: t("label_total_activity"),
      value: `${data ? data?.length : "-"} Kegiatan`,
      icon: ICON_CONSTANTS.ROUNDED_FIELD
    },
    {
      title: t("label_land_area_worked"),
      value: `${data ? convertM2ToHectare(area) : "-"} Ha`,
      icon: ICON_CONSTANTS.ROUNDED_LOCATION
    }
  ]

  return (
    <>
      <div className={"px-21"}>
        <div className={"border p-10 mt-10 d-flex align-items-center justify-content-between"}>
          {dataListCardHeader.map((item, i) => (
            <div key={i} className={"d-flex align-items-center  m-auto"} style={{ gap: 8 }}>
              <SVG src={item.icon} />
              <div>
                <div>{item.title}</div>
                <div className={"font-weight-bolder"}>{item.value}</div>
              </div>
            </div>
          ))}
        </div>
        <div className={"mt-10 accordion_bulk_approve_order"}>
          <Accordion
            items={datalist.map((item, index) => ({
              header: (
                <>
                  <h3 className="card-label mb-8">
                    {item?.area_name ?? "-"}
                    {" ("}
                    {item?.is_seedling_package &&
                    (item?.activity_type_enum === AREA_ACTIVITY_TYPE.SEEDLING ||
                      item?.activity_type_enum === AREA_ACTIVITY_TYPE.PLANTING)
                      ? `${item?.activity_name} ${t("label_seedling_package")}`
                      : item?.activity_name ?? "-"}
                    {")"}
                  </h3>
                </>
              ),
              content: (
                <Fragment key={index}>
                  <AccordionContent data={item} />
                </Fragment>
              )
            }))}
          />
        </div>
      </div>
    </>
  )
}
